import React from 'react';
import { DialogProps, Dialog, styled } from '@mui/material';

type Props = DialogProps;

const StyledDialog = styled(Dialog)(({ theme }) => ({
  '.MuiPaper-root': {
    minWidth: 500,
    borderRadius: '1.5rem',
    backgroundImage: 'none',
  },
  '.MuiDialogActions-root': {
    padding: 16,
  },
}));

export const MuiDialog: React.FC<Props> = (props) => <StyledDialog {...props} />;
